import { MODAL_STATUS } from '../consts';
import { ValueOf } from '../types';

export const createModalMessageBody = (type: ValueOf<typeof MODAL_STATUS>, title: string, description: string) => ({
  type,
  title,
  description,
});
